import styled from '@emotion/styled'

export const OrganizationFeaturesSelectionWrapper = styled.div``
